import type {
  CreateTagReply,
  CreateTagRequest,
  DeleteTagReply,
  DeleteTagRequest,
  GetTagReply,
  GetTagRequest,
  ListTagsReply,
  ListTagsRequest,
  UpdateTagReply,
  UpdateTagRequest,
} from '@/types';
import api from './api';

export const tagApi = {
  // 创建标签
  createTag: async (data: CreateTagRequest): Promise<CreateTagReply> => {
    return api.post('/api/v1/tags', data);
  },

  // 获取标签
  getTag: async (data: GetTagRequest): Promise<GetTagReply> => {
    return api.post('/api/v1/tags/get', data);
  },

  // 更新标签
  updateTag: async (data: UpdateTagRequest): Promise<UpdateTagReply> => {
    return api.post('/api/v1/tags/update', data);
  },

  // 删除标签
  deleteTag: async (data: DeleteTagRequest): Promise<DeleteTagReply> => {
    return api.post('/api/v1/tags/delete', data);
  },

  // 列表查询标签
  listTags: async (data: ListTagsRequest): Promise<ListTagsReply> => {
    return api.post('/api/v1/tags/list', data);
  },
};
